import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from 'src/app/services/communication.service';
import { MessageService } from 'primeng/api';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-link-twilio',
  templateUrl: './link-twilio.component.html',
  styleUrls: ['./link-twilio.component.scss'],
  providers: [MessageService]
})
export class LinkTwilioComponent implements OnInit, OnChanges {
  @Input() partner;
  @Input() currentData;
  @Input() modal;

  @Output() onConnected = new EventEmitter();

  public busy = true;
  public connecting = false;
  public updating = false;

  public accountSID: string = null;
  public authToken: string = null;
  public phoneNumberSID: string = null;
  public phoneNumber: string = null;
  public messagingServiceSID: string = null;
  public twilioIncomingWebhookURL: string = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private communicationService: CommunicationService,
    private translate: TranslateService,
    public messageService: MessageService,
    private appConfig: AppConfig                                                              
  ) { }                                                     

  ngOnInit() {
    this.busy = false;
    this.setTwillioIncomingWebhookURL();
  }

  setTwillioIncomingWebhookURL() {
    const newAPI = this.appConfig.getEnvironmentNew();
    this.twilioIncomingWebhookURL = `${newAPI.url}/v4.0/Messaging/IncomingSMSWebhook/Twilio?code=${newAPI.key}`;
  }

  ngOnChanges(changes) {
    if (changes.currentData && changes.currentData.currentValue) {
      const data = changes.currentData.currentValue;
      this.accountSID = data.accountSID;
      this.authToken = data.authToken;
      this.phoneNumberSID = data.phoneNumberSID;
      this.phoneNumber = data.phoneNumber;
      this.messagingServiceSID = data.messagingServiceSID;
    }
  }

  isValid() {
    if (this.accountSID == null || this.accountSID.length <= 0 ||
      this.authToken == null || this.authToken.length <= 0 ||
      this.phoneNumberSID == null || this.phoneNumberSID.length <= 0 ||
      this.phoneNumber == null || this.phoneNumber.length <= 0
    ) {
      return true;
    }

    return false;
  }

  connect() {
    this.connecting = true;

    this.communicationService.connectStaticAccount(this.partner.ID,
      {
        TextPlatformSystemId: 3,
        Twilio: {
          AccountSID: this.accountSID,
          AuthToken: this.authToken,
          PhoneNumberSID: this.phoneNumberSID,
          PhoneNumber: this.phoneNumber,
          messagingServiceSID: this.messagingServiceSID
        }
      }
    ).subscribe({
    next: res => {
      this.connecting = false;
      this.onConnected.emit();
    },
    error: err => {
      this.connecting = false;
       console.error('Connection error:', err); 
      this.messageService.add({
            life: 5000,
            detail: 'Failed to connect account. Please check your details and try again.',
          });     
    }
  });
  }

  update() {
    this.updating = true;

    this.communicationService.saveData(this.partner.ID,
      {
        TextPlatformSystemId: 3,
        Twilio: {
          AccountSID: this.accountSID,
          AuthToken: this.authToken,
          PhoneNumberSID: this.phoneNumberSID,
          PhoneNumber: this.phoneNumber,
          messagingServiceSID: this.messagingServiceSID
        }
      }
    ).subscribe(res => {
    this.updating = false;
    });
  }

  done() {
    this.onConnected.emit();
  }


}
